import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import styles from './styles';

const useStyles = createUseStyles(styles, 'WidgetLayout');

const WidgetLayout = memo(({ children, header, footer, id, isSelected, getRef }) => {
    const classes = useStyles();

    return (
        <div
            ref={(ref) => getRef?.(ref)}
            id={id}
            className={classnames(classes.root, {
                [classes.selected]: isSelected,
            })}
        >
            <div className={classes.header}>{header && header}</div>
            <div
                className={classnames(classes.content, {
                    [classes.withFooter]: !!footer,
                })}
            >
                {children}
            </div>
            {footer && <div className={classes.footer}>{footer}</div>}
        </div>
    );
});

export default WidgetLayout;
